<template>
  <div>
    <div class="mb-0">{{ title }}:</div>
    <v-select
      v-model="value"
      ref="vSelect"
      :items="[]"
      :placeholder="selectedTitle"
      :menu-props="
        !isMobileView ? { contentClass: 'search-wide-input-menu' } : {}
      "
      outlined
      dense
      hide-details
    >
      <template v-slot:no-data>
        <div class="px-3 py-8">
          <v-chip
            v-for="(brOption, brIndex) in options"
            :key="brIndex"
            :small="!isMobileView"
            :dark="value === brOption.value"
            :color="value !== brOption.value ? 'grey lighten-4' : '#219bc8'"
            class="mr-1 my-2"
            :style="
              brIndex === 0 && options.length > 4 ? 'display: table;' : ''
            "
            @click="select(brOption.value)"
          >
            {{ brOption.text }}
          </v-chip>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'

export default {
  name: 'SearchRoomCountSelect',

  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    options: {
      type: Array,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selecting: true,
    }
  },

  computed: {
    ...sharedComputed,

    selectedTitle() {
      return this.options.filter((option) => option.value === this.value)?.[0]
        ?.text
    },
  },

  methods: {
    select(value) {
      this.$emit('input', value)
      this.close()
    },

    close() {
      const searchEl = this.$refs.vSelect
      if (searchEl) {
        searchEl.blur()
      }
    },
  },
}
</script>
